import * as tslib_1 from "tslib";
import axios from 'axios';
import camelizeKeys from './camelize-keys';
import snakelizeKeys from './snakelize-keys';

var onError = function onError(error) {
  var errorResponse = error;

  if (error.code === 'ECONNABORTED') {
    errorResponse = {
      isTimeoutError: true,
      statusCode: 'ECONNABORTED'
    };
  } else if (error.response) {
    errorResponse = {
      errors: error.response.data,
      statusCode: error.response.status,
      isTimeoutError: false
    };
  } else {
    // invoke when something broken inside promise
    console.log('axios.onError', error); // eslint-disable-line
  }

  return Promise.reject(errorResponse); // ?? todo reject?
};

var instance = axios.create({
  withCredentials: true,
  timeout: 15000,
  headers: {
    common: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache'
    }
  },
  // @ts-ignore
  transformRequest: [snakelizeKeys].concat(axios.defaults.transformRequest),
  // @ts-ignore
  transformResponse: axios.defaults.transformResponse.concat(camelizeKeys)
});
instance.all = axios.all;
instance.spread = axios.spread;
instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;
instance.onError = onError;
instance.interceptors.request.use(function (config) {
  return tslib_1.__assign({}, config, {
    params: snakelizeKeys(config.params)
  });
});
export default instance;